import { REDUCER_NAMESPACE } from './name';
export const SET_EXTENSIONS = `${REDUCER_NAMESPACE}/SET_EXTENSIONS`;
export const SET_HAS_NEW_EXTENSIONS = `${REDUCER_NAMESPACE}/SET_HAS_NEW_EXTENSIONS`;
export const RESET_STATE = `${REDUCER_NAMESPACE}/RESET_STATE`;
